import { Box, Stack } from '@mui/material'
import { EXTRA_BOTTOM_SPACE, Footer, tokens, TOOLBAR_HEIGHT } from 'ComponentLibrary'
import { useEffect, useState } from 'react'
import { useMarketData } from 'ClientPortal/src/pages/MarketData/MarketDataPage.data'
import { MarketDataSidebar } from 'ClientPortal/src/pages/MarketData/Sidebar/MarketDataSidebar'
import { MarketDataExplorer } from 'ClientPortal/src/pages/MarketData/Explorer/MarketDataExplorer'
import { AssetLocation } from 'ClientPortal/src/pages/MarketData/types'

export const MarketDataPage = () => {
    const [selectedLocation, setSelectedLocation] = useState<AssetLocation | undefined>(undefined)
    const { assets, isAssetsPending, marketData, isMarketDataPending, selectedAsset } = useMarketData({
        coordinates: selectedLocation?.address?.coordinates,
        selectedAssetId: selectedLocation?.uuid,
    })

    useEffect(() => {
        // We need to refetch the selectedAsset on its own, since the MultiAssetValueOverview query does not return all the optional fields we need
        if (selectedAsset) {
            setSelectedLocation(selectedAsset)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedAsset?.uuid])

    return (
        <Stack direction="row">
            <MarketDataSidebar
                assets={assets}
                selectedLocation={selectedLocation}
                setSelectedLocation={setSelectedLocation}
                isAssetsPending={isAssetsPending}
            />
            <Stack
                width="100%"
                direction="column"
                gap={tokens.SizingSpacing300}
                padding="32px 20px 0 40px"
                minHeight={`calc(100vh - ${TOOLBAR_HEIGHT} - 1px)`}
                minWidth="650px"
                sx={{ backgroundColor: tokens.ColorSurfaceAccentGreyDefault, overflowX: 'overlay' }}
                justifyContent="space-between"
            >
                <MarketDataExplorer selectedLocation={selectedLocation} isMarketDataPending={isMarketDataPending} marketData={marketData} />
                <Box marginTop={EXTRA_BOTTOM_SPACE}>
                    <Footer />
                </Box>
            </Stack>
        </Stack>
    )
}
